/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Form/Item/Text.ts" />
namespace HA.Core.Controller.Form {
    import Text = HA.Core.HTML.Form.Text;

    export class TextController extends FormItemController {

        /**
         *
         * @returns {boolean}
         */
        public isInputItem() {
            return true;
        }

        /**
         *
         * @returns {any}
         */
        protected createItem() {
            return new Text(toMap({tag: this.getTag(), textarea : this.get("textarea")}));
        }
    }
}
